import React, { useState, useEffect } from 'react'
import { Form, Input, Button } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { useAssetDelivery } from './AssetDeliveryContext'
import { UrlProduct } from './types'

interface Props {
  product: UrlProduct
}

interface UrlFormProps {
  onSubmit: (values: any) => void
}

function UrlForm({onSubmit}: UrlFormProps) {
  const [form] = Form.useForm()
  const [, forceUpdate] = useState<any>() // To disable submit button at the beginning.

  useEffect(() => {
    forceUpdate({})
  }, [])

  function onFinish(values: any) {
    onSubmit(values)
    form.resetFields()
  }

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onFinish}
    >
      <Form.Item
        name="url"
        rules={[{
          required: true,
          message: 'URL er påkrevd',
        }, {
          pattern: /https?:\/\/.{2,}/,
          message: 'URL-en er ikke gyldig',
        }]}
      >
        <Input placeholder="URL" />
      </Form.Item>
      <Form.Item shouldUpdate>
        {() => (
          <Button
            type="primary"
            htmlType="submit"
            disabled={(
              !form.isFieldsTouched(true) ||
              form.getFieldsError().filter(({errors}) => errors.length).length > 0
            )}
          >
            Legg til URLen
          </Button>
        )}
      </Form.Item>
    </Form>
  )
}

function UrlDelivery({ product } : Props) {
  const { createAssets, deleteAsset } = useAssetDelivery()

  function handleSubmit(values: any) {
    return createAssets(product.id, [{
      contentType: 'application/vnd.inviso.url',
      url: values.url,
    }])
  }

  return (
    <div className="url-delivery">
      {product.state === 'booked' && (
        <UrlForm onSubmit={handleSubmit} />
      )}
      <div className="url-assets">
        {product.assetDeliveries.map((asset: any) => (
          <span key={asset.id} className="url-asset">
            {asset.url}
            {product.state === 'booked' && (
              <Button
                size="small"
                icon={<CloseOutlined />}
                onClick={() => deleteAsset(asset)}
              />
            )}
          </span>
        ))}
      </div>
    </div>
  )
}

export default UrlDelivery
